<template>
  <div>
  <Card>
      <Row>
        <i-col span="18">
          <Form ref="searchForm" inline :model="searchForm" :label-width="60" @submit.native.prevent>
            <FormItem label="用户名" prop="name">
              <i-input v-model="searchForm.name" placeholder="请输入用户名" style="width: 200px;"></i-input>
            </FormItem>
            <FormItem :label-width="0">
              <Button type="primary" @click="getPermList()">搜索</Button>
              <Button @click="searchReset" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </i-col>
        <i-col span="6">
          <Button style="float: right;" @click="addPerm" type="primary" :style="{marginBottom: '10px'}">添加</Button>
        </i-col>
       </Row>
      <tables search-place="top" v-model="tableData" :columns="columns" @on-sort-change="changeSort"/>
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getPermList"></page>
        </div>
     </Row>
      <Drawer
        title="添加"
        v-model="change"
        width="720"
        :mask-closable="true"
        @on-close="drawerClose"
      >
        <i-form ref="formItem" :model="formItem" :label-width="100" :rules="ruleValidate">
          <form-item label="名称" prop="name">
            <i-input  v-model="formItem.name"></i-input>
          </form-item>
          <form-item label="跳板机用户" prop="users">
             <i-select v-model="formItem.users" style="width:90%;" placeholder="请选择用户" multiple>
              <i-option v-for="item in user_all" :value="item.user_id" :key="item.user_id" :label="item.user"></i-option>
             </i-select>
          </form-item>
          <form-item label="系统用户名" prop="system_users_single">
            <i-select v-model="formItem.system_users_single" style="width:90%;" placeholder="请选择用户" @on-change="onSelectSystemUser" filterable>
              <i-option v-for="item in system_users_all" :value="item.id" :key="item.id" :label="item.username"></i-option>
             </i-select>
          </form-item>
          <form-item label="资产" prop="assets">
            <i-select v-model="formItem.assets"  multiple  style="width: 90%;" :disabled="assetsDisabled" filterable>
              <i-option v-for="item in assetOptions" :value="item.id" :key="item.id" :label="item.inner_ip"></i-option>
            </i-select>
          </form-item>
          <form-item label="激活" prop="is_active">
            <i-switch v-model="formItem.is_active" size="large">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </form-item>
          <form-item label="描述" prop="description">
            <i-input  v-model="formItem.description"></i-input>
          </form-item>
          <form-item>
           <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
           <i-button style="margin-left: 8px" @click="change=false">取消</i-button>
          </form-item>
        </i-form>
        <spin fix v-if="changeLoadingShow">
          <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
          <div>请求中</div>
        </spin>
      </Drawer>
    </Card>
  </div>
</template>
<script>
import Tables from '_c/tables'
// import { GetALLUsers } from '@/api/user'
import { getPermList, savePerm, deletePerm, editPerm, getPermDetail, getSysUserALL, getSpringBoardUserALL } from '@/api/springboard'
import { getOpsCenterAllServer } from '@/api/opscenter'
export default {
  name: 'PermList',
  components: {
    Tables
  },
  data () {
    return {
      count: 1,
      size: 10,
      page: 1,
      change: false,
      ordering: null,
      assetsDisabled: true,
      columns: [
        { title: 'ID', key: 'id', align: 'center', sortable: 'custom' },
        { title: '名称', key: 'name', align: 'center' },
        { title: '用户数', key: 'users', align: 'center' },
        { title: '资产数', key: 'assets', align: 'center' },
        {
          title: '状态',
          key: 'is_active',
          render: (h, params) => {
            const row = params.row
            const color = row.is_active === true ? 'success' : 'error'
            const text = row.is_active === true ? '已激活' : '未激活'
            return h('Tag', {
              props: {
                type: 'dot',
                color: color
              }
            }, text)
          }
        },
        {
          title: '操作',
          align: 'center',
          render: (h, params) => {
            if (this.$store.state.user.superuser) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    title: 'Edit'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.editPerm(params)
                    }
                  }
                }, 'Edit'),
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?',
                    transfer: true
                  },
                  on: {
                    'on-ok': () => {
                      this.deletePerm(params.row.id)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small',
                      title: 'Delete'
                    },
                    style: {
                      marginRight: '5px'
                    }
                  }, 'Delete')
                ])
              ])
            } else {}
          }
        }
      ],
      tableData: [],
      user_all: [],
      assetOptions: [],
      system_users_all: [],
      system_users_sel: [],
      changeLoadingShow: false,
      searchForm: {
        name: null
      },
      formItem: {
        id: null,
        name: '',
        users: [],
        system_users_single: 0,
        system_users: [],
        assets: [],
        is_active: true,
        description: ''
      },
      listStyle: {
        width: '250px',
        height: '300px'
      },
      ruleValidate: {
        name: [{ required: true, message: '权限名称不能为空 !', trigger: 'blur' }],
        users: [{ required: true, message: '请选择要分配权限的跳板机用户', trigger: 'change', type: 'array' }],
        system_users_single: [{ required: true, message: '请选择要登录主机的系统用户名', trigger: 'change', type: 'number' }],
        assets: [{ required: true, message: '请选择要登录的主机', trigger: 'change', type: 'array' }]
      }
    }
  },
  methods: {
    getPermList (value = 1) {
      this.page = value
      let params = {
        page: this.page,
        ordering: this.ordering,
        search: this.searchForm.name
      }
      getPermList(params).then(res => {
        this.tableData = res.data.results
        this.tableData.map((item, index) => {
          item.users = item.users instanceof Array ? item.users.length : 0
          item.assets = item.assets instanceof Array ? item.assets.length : 0
        })
        this.count = res.data.count
      })
    },
    addPerm () {
      // this.assetsDisabled = false
      this.fetchAllUserData()
      this.getSysUsers()
      this.formItem.id = null
      this.change = true
    },
    editPerm (params) {
      this.assetsDisabled = false
      // 取当前行数据 赋值 给表单
      getPermDetail(params.row.id).then(res => {
        let assets = res.data.assets
        let os = null
        this.formItem.name = res.data.name
        this.formItem.users = res.data.users
        this.formItem.system_users = res.data.system_users
        this.formItem.system_users_single = Number(res.data.system_users[0])
        this.formItem.description = res.data.description
        // this.formItem.assets = []
        this.formItem.id = res.data.id
        this.change = true
        this.system_users_sel = this.system_users_all
        // 根据选择的操作系统，取cmdb 的对应的主机 0  linux  1  windows
        this.system_users_sel = this.system_users_sel.filter(item => {
          return item['id'] === this.formItem.system_users_single
        })
        if (this.system_users_sel) {
          os = this.system_users_sel[0].os
        }
        let params = {
          os: os
        }
        getOpsCenterAllServer(params).then(res => {
          this.assetOptions = res.data
          this.formItem.assets = assets
        })
      })
      // this.change = true
    },
    deletePerm (id) {
      deletePerm(id).then(res => {
        if (res.data.code === 200) {
          this.$Message.success(res.data.msg)
          this.getPermList()
        } else {
          this.$Message.error(res.data.msg)
        }
      })
    },
    drawerClose () {
      let that = this.formItem
      that.id = null
      that.name = ''
      that.users = []
      that.system_users_single = 0
      that.system_users = []
      that.assets = []
      that.description = ''
    },
    fetchAllUserData () {
      getSpringBoardUserALL().then(res => {
        this.user_all = res.data
      })
    },
    changeSort (column) {
      if (column.key === 'id') {
        if (column.order === 'asc') {
          this.ordering = 'id'
        } else {
          this.ordering = '-id'
        }
      }
      this.getPermList()
    },
    searchReset () {
      this.searchForm.name = null
    },
    onSelectSystemUser (value) {
      let os = null
      this.formItem.assets = []
      this.assetsDisabled = false
      this.system_users_sel = this.system_users_all
      // 根据选择的操作系统，取cmdb 的对应的主机 0  linux  1  windows
      this.system_users_sel = this.system_users_sel.filter(item => {
        return item['id'] === value
      })
      if (this.system_users_sel) {
        os = this.system_users_sel[0].os
      }
      let params = {
        os: os
      }
      getOpsCenterAllServer(params).then(res => {
        this.assetOptions = res.data
      })
    },
    getSysUsers () {
      getSysUserALL().then(res => {
        this.system_users_all = res.data
      })
    },
    handleSubmit (name) {
      // let that = this.formItem
      this.$refs[name].validate((valid) => {
        if (valid) {
          let systemUsersArray = []
          systemUsersArray.push(this.formItem.system_users_single)
          this.formItem.system_users = systemUsersArray
          this.changeLoadingShow = true
          if (this.formItem.id) {
            editPerm(this.formItem).then(res => {
              if (res.data.code === 200) {
                this.change = false
                this.getPermList()
              } else {
                // this.$Notice.error({title: res.data})
                this.$Message.error(res.data.msg)
              }
            }).catch(res => {
              console.log(res.response)
              this.$Notice.error({
                title: '操作失败！ 错误状态码:' + res.request.status,
                desc: res.request.responseText
              })
            })
          } else {
            savePerm(this.formItem).then(res => {
              if (res.data.code === 200) {
                this.change = false
                this.getPermList()
              } else {
                // this.$Notice.error({title: res.data})
                this.$Message.error(res.data.msg)
              }
            }).catch(res => {
              console.log(res.response)
              this.$Notice.error({
                title: '操作失败！ 错误状态码:' + res.request.status,
                desc: res.request.responseText
              })
            })
          }
        } else {
          this.$Notice.error({title: '请检查输入框！'})
        }
        this.changeLoadingShow = false
      })
    }
  },
  mounted: function () {
    this.fetchAllUserData()
    this.getSysUsers()
    this.getPermList()
  }
}
</script>

<style>
.ivu-poptip-body {
  text-align: left !important;
}
</style>
